import { supabase } from "../supabase/SupabaseClient";

/* Multas de tránsito por DNI (en vez de por dominio), vía
 * fibot-vehicle-intelligence.
 *
 * NO SE GUARDA -- a diferencia de `multas.js` (por dominio), acá no hay un
 * `registrarConsulta`. Una consulta por DNI puede traer actas de varios
 * dominios (o de ninguno -- CABA no expone el dominio por acta en este
 * modo), y `multas`/`multas_registrar_consulta` están pensados por
 * dominio: guardar esto ahí mezclaría el dato de una persona con el de un
 * vehículo sin una clave limpia para releerlo. Se muestra en vivo y se
 * pierde al salir de la pantalla -- mismo criterio que usa el bot de
 * WhatsApp para esto mismo.
 *
 * `sexo` ("M"/"F") es opcional pero cambia el alcance: PBA y SINAI lo
 * exigen en su propio formulario (no es una decisión nuestra) y sin él la
 * edge function sólo consulta CABA.
 */
export const consultarMultasPersona = async (dni, sexo) => {
  const { data, error: fnError } = await supabase.functions.invoke(
    "consultar-multas-persona",
    { body: { dni, sexo: sexo || undefined } },
  );

  if (fnError || data?.error) {
    let mensajeReal = data?.error;
    if (!mensajeReal && fnError?.context?.json) {
      try {
        const body = await fnError.context.json();
        mensajeReal = body?.error;
      } catch {
        // el body no era JSON (ej. timeout del gateway) -- seguimos con
        // fnError.message.
      }
    }
    throw new Error(mensajeReal || fnError?.message || "Error desconocido");
  }

  return data;
};
